import styled from 'styled-components'
import { theme } from '../../theme/theme'
import { inputShadow } from '../../theme/shadows'
import { printCardOutline } from '../../theme/print'

export const axisStyle = {
  fontSize: `${theme.fontSize.xxsmall}px`,
  fontFamily: theme.font.body,
  fill: theme.color.grey4,
  fontWeight: 500,
}

// Band labels read as words rather than axis ticks: bigger and unbolded.
export const bandAxisStyle = {
  fontSize: `${theme.fontSize.xsmall}px`,
  fontFamily: theme.font.body,
  fill: theme.color.greyBlue,
  fontWeight: 400,
}

// Horizontal padding for the x-axis so the first/last points sit near the edges.
export const chartXAxisPadding = (isMobileDevice: boolean) => ({
  left: isMobileDevice ? 10 : 20,
  right: isMobileDevice ? 10 : 20,
})

export const ChartContainer = styled.div`
  padding: ${theme.spacing.mediumLarge}px;
  background-color: ${theme.color.white};
  border-radius: 16px;
  ${inputShadow}
  ${printCardOutline}
  @media screen and (max-width: ${theme.breakpoint.medium}px) {
    padding: ${theme.spacing.medium}px;
  }

  @media print {
    break-inside: avoid;
  }
`
export const ChartHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 ${theme.spacing.tiny}px;
  margin-bottom: ${theme.spacing.small}px;

  & > p:first-child {
    white-space: nowrap;
    margin-right: 10px;
    @media screen and (max-width: ${theme.breakpoint.xlarge}px) {
      white-space: break-spaces;
      margin-right: 0px;
    }
  }

  @media screen and (max-width: ${theme.breakpoint.xlarge}px) {
    flex-direction: column;
    align-items: flex-start;
    margin-bottom: ${theme.spacing.xsmall}px;
  }
`

export const PLOT_SURFACE_GAP = 0

export const ChartTooltip = styled.span`
  position: absolute;
  bottom: calc(100% + 6px);
  left: 50%;
  transform: translateX(-50%);
  padding: ${theme.spacing.xsmall}px ${theme.spacing.small}px;
  border-radius: 8px;
  background-color: ${theme.color.black};
  color: ${theme.color.white};
  font-family: ${theme.font.body};
  font-size: ${theme.fontSize.xsmall}px;
  line-height: 18px;
  white-space: nowrap;
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.12s ease-in-out;
  z-index: 2;
`

// Round steps that just clear the data: a fixed ceiling would flatten a small customer's bars.
const TICK_STEPS = [1, 2, 5, 10, 20, 25, 50, 100, 200, 500]

export const buildTicks = (max: number): number[] => {
  const step = TICK_STEPS.find((candidate) => Math.ceil(max / candidate) <= 5) ?? 1000
  const count = Math.max(Math.ceil(max / step), 1)
  return Array.from({ length: count + 1 }, (_, index) => index * step)
}
